import { Outlet } from 'react-router-dom'

export const ReferralsPageLayout = () => {
  return <Outlet />
}
